import { useMemo } from 'react';

import { encoderQr } from '../lib/qr-code';

/** Marge blanche réglementaire autour du code : quatre modules. */
const MARGE = 4;

/**
 * QR code dessiné en SVG, entièrement dans le navigateur (AB#296).
 *
 * Noir sur blanc dans les DEUX apparences : un appareil photo lit mal un code
 * inversé, et le thème sombre de la console n'a pas à s'appliquer ici. Une
 * seule `<path>` : pas des centaines de nœuds à redessiner.
 */
export function QrCode({
  valeur,
  taille = 208,
  libelle,
}: {
  valeur: string;
  taille?: number;
  libelle: string;
}) {
  const { chemin, cote } = useMemo(() => {
    const m = encoderQr(valeur);
    let d = '';
    m.forEach((ligne, y) =>
      ligne.forEach((sombre, x) => {
        if (sombre) d += `M${x + MARGE} ${y + MARGE}h1v1h-1z`;
      }),
    );
    return { chemin: d, cote: m.length + 2 * MARGE };
  }, [valeur]);

  return (
    <svg
      role="img"
      aria-label={libelle}
      width={taille}
      height={taille}
      viewBox={`0 0 ${cote} ${cote}`}
      shapeRendering="crispEdges"
      style={{ display: 'block', borderRadius: 4 }}
    >
      <rect width={cote} height={cote} fill="#ffffff" />
      <path d={chemin} fill="#000000" />
    </svg>
  );
}
